import { TemplateData } from "@/store/builderSlice";
import { getUserId } from "@/utils/builder/userUtils";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://api.nestingale.com/v1"
});
export const saveTemplateThunk = createAsyncThunk(
    "builder/saveTemplate",
    async (config: {}, { rejectWithValue, getState }) => {
        try {
            let url = `/api/templates`;
            let method = 'post';
            const methodHandlers = {
                post: axiosInstance.post,
                put: axiosInstance.put,
            };
            const templateJson: TemplateData = Object.assign({}, (getState() as any).builder.template.templateData);
            const templateId = templateJson.templateId;
            if (templateId) {
                url += `/${templateId}`;
                method = 'put';
                delete templateJson.templateId;
            }

            //@ts-ignore
            const result = await methodHandlers[method](url, templateJson,
                {
                    headers: {
                        'Designer-Id': getUserId()
                    }
                })
                .then((response: any) => {
                    return response.data
                }, (err: any) => {
                    const errorObj = Object.assign({ description: "NEST_SPA:Slices:saveProject:Exception", errorCode: "NEST_SPA:BUILDER_PAGE:SAVE_PROJECT" }, err)
                    console.log(errorObj);
                    throw errorObj;
                });
            console.log("Project saved :: ", result);
            // return templateId || result.templateId;
            return result;
        } catch (err) {
            console.log({ description: "NEST_SPA:Slices:saveProject:Exception", errorCode: "NEST_SPA:BUILDER_PAGE:SAVE_PROJECT", err_desc: (err as Error).message, err_stack: (err as Error).stack });
            return rejectWithValue(err);
        }
    }
);

export const fetchTemplateDataThunk = createAsyncThunk(
    'template/fetchTemplateData',
    async (templateId: string, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/api/templates/${templateId}`, {
                headers: {
                    'Designer-Id': getUserId()
                },
                timeout: 10000,
            });

            if (response.status !== 200) {
                return rejectWithValue(`Unexpected response: ${response.status}`);
            }
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data?.message || 'Server error');
            } else if (error.request) {
                return rejectWithValue('No response from server. Please try again.');
            } else {
                return rejectWithValue(error.message || 'Something went wrong');
            }
        }
    }
);